export const template = (
  templateString: string,
  object: Record<string, string | number>,
) =>
  Object.keys(object).reduce(
    (current, key) => current.replace(`{{${key}}}`, String(object[key])),
    templateString,
  );
